import React, { forwardRef } from "react";
import "./button.css";
import { ButtonProps } from "../../GameTypes/game.type";

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, onClick, variant = "primary", disabled = false, className = "", ...props }, ref) => {
    return (
      <button
        ref={ref}
        className={`btn btn-${variant} ${disabled ? "btn-disabled" : ""} ${className}`}
        onClick={onClick}
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    );
  }
);

export default Button;
